<template>
  <div class="dropdown-button">
    <AppButton
      :mode="button.mode"
      :size="button.size"
      :color="button.color"
      :class="button.class"
      @click.stop="toggleMenu"
    >
      <div class="font-medium text-gray-medium truncate mx:w-24">
        {{ button.text }}
      </div>
      <template #icon-right>
        <slot name="icon">
          <AppIcon
            :name="icon.name"
            :size="icon.size"
            :color="icon.color"
            class="ml-1"
          />
        </slot>
      </template>
      <template #icon-left>
        <div class="dropdown-button-arrow">
          <slot name="arrow">
            <AppIcon
              :name="`chevron-${!isOpen ? 'down' : 'up'}`"
              color="text-gray-medium"
            />
          </slot>
        </div>
      </template>
    </AppButton>
    <div v-if="isOpen" class="dropdown-button-list" :class="offsetClass">
      <component :is="listName" />
    </div>
  </div>
</template>

<script>
import AppButton from '@library/element/button'
import AppIcon from '@library/element/icon'
import ListAvatar from '@library/element/dropdown/dropdown-list/avatar'
import AvatarDashboard from '@library/element/dropdown/dropdown-list/avatar-dashboard'
export default {
  name: 'DropdownButton',
  components: {
    avatar: ListAvatar,
    AvatarDashboard,
    AppButton,
    AppIcon
  },
  props: {
    listName: {
      type: String,
      default: 'avatar'
    },
    offsetClass: {
      type: String,
      default: 'right-0'
    },
    button: {
      type: Object,
      default: () => {
        return {
          text: '',
          mode: 'outline',
          size: 'sm',
          color: 'transparent',
          class: ''
        }
      }
    },
    icon: {
      type: Object,
      default: () => {
        return {
          name: 'account',
          color: 'text-blue-primary',
          size: 'small'
        }
      }
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.setClosed()
      }
    }
  },
  methods: {
    toggleMenu () {
      this.isOpen = !this.isOpen
    },
    setClosed () {
      const body = document.querySelector('body')
      body.addEventListener('click', (e) => {
        e.stopPropagation()
        this.isOpen = false
      })
    }
  }
}
</script>

<style lang="scss">
.dropdown-button {
  @apply inline-block relative z-10;
  .btn .btn-icon {
    @apply ml-0;
  }
  &-arrow {
    @apply xl:pr-2;
  }
  &-list {
    @apply absolute  bg-white shadow-lg rounded-b top-full; //min-w-[185px]
    &__item {
      @apply bg-white border-gray-medium border-b text-xs
        font-normal p-1.5 cursor-pointer hover:text-blue-primary transition-colors hover:border-blue-hover;
      &:last-child {
        @apply border-none;
      }
    }
  }
}
.search {
  .dropdown-button {
    &-list {
      min-width: 100vw;
      // @apply md:min-w-[185px];
    }
  }
}
</style>
